export const addFontFamilyModal = {
  extends: 'ModalWindow',
  tag: 'form',
  state: {
    familyName: '',
    value: {
      type: 'serif',
      value: ['inherit']
    }
  },
  ModalHeader: {
    title: 'Font Family',
    p: 'Set up font-family and fonts ordering'
  },
  Flex: {
    props: {
      flexAlign: 'stretch center',
      gap: 'C',
      padding: '0 E 0 0'
    },
    Fields: {
      flexFlow: 'y',
      gap: 'B1',
      InputField: {
        Title: {
          text: '{{ editor.addFontFamily.name | polyglot }}'
        },
        Input: {
          placeholder: (el) => el.call('polyglot', 'editor.addFontFamily.namePlaceholder'),
          value: (el, s) => s.familyName,
          onKeyup: (e, el, s) => {
            s.update({
              [el.parent.key]: el.node.value
            })
          },
          onChange: (e, el, s) => {
            if (s.familyName) return
            const familyName = toCamelCase(s.familyName)
            s.update({
              familyName
            })
          }
        }
      },
      GroupField: {
        Title: {
          text: '{{ editor.addFontFamily.type | polyglot }}'
        },
        DropdownField: {
          Value: {
            Text: {
              text: (el, s) =>
                (s.value && s.value.type) ||
                el.call('polyglot', 'editor.addFontFamily.allCategories')
            }
          }
        }
      }
    },
    Group: {
      state: 'value',
      padding: '0 0 0 B2',
      style: {
        borderLeft: '.06)'
      },
      Title: {
        text: '{{ editor.addFontFamily.ordering | polyglot }}'
      },
      Content: {
        Tools: {
          flexFlow: 'y',
          gap: 'A',
          childExtends: 'OrderingItem',
          children: (el, state) => {
            return Object.values(state.value)
          },
          childrenAs: 'state'
        },
        SquareButton: {
          theme: 'quaternary',
          icon: 'plus',
          margin: 'A 0 B1 A1',
          onClick: (ev, el, s) => {
            s.add('inherit')
          }
        }
        // OrderingItem (the row template Tools.childExtends resolves) moved
        // to components/OrderingItem.js and registered there — a bare-string
        // childExtends only resolves against context.components, never a
        // sibling key here (2026-08-14, bare-string extends sweep).
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      text: '{{ common.action.okay | polyglot }}'
    }
  },
  on: {
    submit: (e, el, s) => {
      e.preventDefault()
      const { value, familyName } = s

      if (!familyName || !value) return

      ctx.utils.closeModal(el, s, ctx)
      const t = setTimeout(() => {
        el.updateDesignSystem({
          fontFamily: {
            [familyName]: value
          }
        })
        clearTimeout(t)
      }, 75)
    }
  }
}
